export default "__VITE_ASSET__BirBfm9F__"